var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/SuccessfulContentPaste.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const SuccessfulContentPaste = ({
  color = '#00003D',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "16",
  height: "20",
  viewBox: "0 0 16 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.82 2H14C15.1 2 16 2.9 16 4V18C16 19.1 15.1 20 14 20H2C0.9 20 0 19.1 0 18V4C0 2.9 0.9 2 2 2H5.18C5.6 0.84 6.7 0 8 0C9.3 0 10.4 0.84 10.82 2ZM9 3C9 2.45 8.55 2 8 2C7.45 2 7 2.45 7 3C7 3.55 7.45 4 8 4C8.55 4 9 3.55 9 3ZM13.5 18C13.7761 18 14 17.7761 14 17.5V4.5C14 4.22386 13.7761 4 13.5 4H12.5C12.2239 4 12 4.22386 12 4.5V6C12 6.55228 11.5523 7 11 7H5C4.44772 7 4 6.55228 4 6V4.5C4 4.22386 3.77614 4 3.5 4H2.5C2.22386 4 2 4.22386 2 4.5V17.5C2 17.7761 2.22386 18 2.5 18H13.5ZM4.70611 12.7062L6.29289 14.293C6.68342 14.6835 7.31658 14.6835 7.70711 14.293L11.2954 10.7047C11.6849 10.3151 11.6857 9.68351 11.2975 9.29259C10.9074 8.89971 10.2719 8.89819 9.88039 9.28969L7.35244 11.8176C7.15761 12.0125 6.84189 12.013 6.64645 11.8188L6.11611 11.2917C5.72577 10.9039 5.09522 10.9049 4.70611 11.294C4.31614 11.6839 4.31614 12.3162 4.70611 12.7062Z",
    fill: color
  })
});